import useStorageState from "$src/core/hooks/use-storage-state";
import type { ContentDto } from "$src/core/models/dto";

const MAX_HISTORY_LENGTH = 10;

const useSearchHistory = () => {
  const [historyStatus] = useStorageState("search.recent.status", null);
  const [history, setHistory] = useStorageState("search.recent.items", null);

  const isEnabled = historyStatus !== "disabled";

  const addToHistory = (item: ContentDto) => {
    if (!isEnabled) return;

    setHistory((prev) =>
      [item, ...(prev ?? []).filter((i) => i.id !== item.id)].slice(
        0,
        MAX_HISTORY_LENGTH,
      ),
    );
  };

  const clearHistory = () => {
    setHistory([]);
  };

  return {
    history: isEnabled ? history : null,
    isEnabled,
    addToHistory,
    clearHistory,
  };
};

export default useSearchHistory;
